import { addResources } from '../../../locales';
import en from './en';
import ru from './ru';

addResources({ en, ru });
